import React, { useRef, useState, useEffect, Fragment, Component } from "react";
import {
  Routes,
  Route,
  useSearchParams,
  BrowserRouter,
  useLocation,
} from "react-router-dom";

import Divider from "@mui/material/Divider";
import "bootstrap/dist/css/bootstrap.min.css";
import Alert from "react-bootstrap/Alert";

import axios from "../../../../api/axios";

import FileUpload from "./FileUpload";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import {
  Typography,
  Box,
  Paper,
  Link,
  Grid,
  Radio,
  Select,
  Button,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { url } from "../../../../configlink";
import { useSelector } from "react-redux";

export default function PALinks() {
  const [links, setLinks] = useState();
  const [code, setCode] = useState(undefined);
  const [expiredDate, setExpiredDate] = useState(null);
  const [isMsgShow, setIsMsgShow] = useState(false);

  const [orderId, setOrderId] = useState(undefined);

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  /*async componentDidUpdate(prevProps) {
    //const { match } = this.props;

    //componentDidMount() {
    // console.log(match.params.id)

    const queryParameters = new URLSearchParams(window.location.search);
    const type = queryParameters.get("orderId");

    console.log("type Orderid ==" + type);
    //let params = useParams();
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    //params["id"];
    if (this.props.params.orderId)
      console.log("type Orderid2 ==" + this.props.params["orderId"]);

    const [searchParams, setSerchParams] = useSearchParams();

    consloe.log(searchParams.get("orderId"));

    if (prevProps.open !== this.props.open && this.props.open) {
      this.setState({ open: this.props.open });
    }

    console.log("Componet Did update d OrderId===" + this.props.orderId);
    if (prevProps.orderId !== this.props.orderId) {
      try {
        const response = await axios.get(
          `${url}/api/admin/get_palink_payment_by_orderid`,
          {
            params: {
              orderId: this.props.orderId,
            },
          }
        );
        // [{"links":"https://www.acgtinc.com/forms/RequestPaymentPAPage.php?OrderId=806851","expiredDate":"Dec/30/23","randomPasscode":"7532"}]

        console.log("pa link info gran");
        if (response.data !== undefined && response.data.length > 0) {
          this.setState({
            links: response.data[0].links,
            code: response.data[0].randomPasscode,
            expiredDate: response.data[0].expiredDate,
            isMsgShow: false,
          });
        } else {
          this.setState({
            links: "",
            code: "",
            expiredDate: "",
            isMsgShow: true,
          });
        }
      } catch (error) {
        console.log("error=" + error);
      }
    }
  }
  */

  const cancelForm = () => {
    //this.setState({ open: false });
    //this.state.onClose();
  };

  const initPALink = async () => {
    if (orderId) {
      try {
        const response = await axios.get(
          `${url}/api/admin/get_palink_payment_by_orderid`,
          {
            params: {
              orderId: orderId,
            },
				withCredentials: true,
				headers: {
					'acgt-admin': adminUser
				},
          }
        );
        // [{"links":"https://www.acgtinc.com/forms/RequestPaymentPAPage.php?OrderId=806851","expiredDate":"Dec/30/23","randomPasscode":"7532"}]

        
        if (response.data !== undefined && response.data.length > 0) {
          console.log("RES", response.data)
          setLinks(response.data[0].links);
          setCode(response.data[0].randomPasscode);
          setExpiredDate(response.data[0].expiredDate);
          setIsMsgShow(false);
        } else {
          setLinks("");
          setCode("");
          setExpiredDate("");
          setIsMsgShow(true);
        }
      } catch (error) {
        console.log("error=" + error);
      }
    }
  };

  const handleRegenerate = async () => {
    console.log("handle generate test===" + orderId);
    try {
      const response = await axios.post(
        `${url}/api/admin/post_regenerated_pa_links_by_orderid?orderId=${orderId}`,
        {
          params: {
            orderId: orderId,
          }
        }, 
        {
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );

      if (response != undefined && response.data.length > 0) {        
        setLinks(response.data[0].links);
        setCode(response.data[0].randomPasscode);
        setExpiredDate(response.data[0].expiredDate);
        setIsMsgShow(false);
      } else {
        console.log("error in handleRegenerate function");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleMsgClose = () => {
    setIsMsgShow(false);
    //this.setState({
    //  isMsgShow: false,
    //});
  };

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    console.log("orderid==="+ searchParams.get("orderId"));
    setOrderId(searchParams.get("orderId"));
    initPALink();
  });

  return (
    <div>
      <div style={{ padding: 25, paddingTop: 10, paddingBottom: 30 }}>
        <div>
          <Box sx={{ my: 3, mx: 2 }}>
            <Grid container alignItems="center" spacing={10}>
              <Grid item xs>
                <p className="font-bold text-[var(--color-primary-purple)] text-[22px]">
                  Request PA Approval Link & Notice
                </p>
              </Grid>
            </Grid>
            <Divider component="div" role="presentation" className="mt-2" />

            {/* <Grid container alignItems="center" spacing={10}>
              <Grid item xs>
                <Typography color="text.secondary" variant="body2">
                  Please be sure you need to do not make sub folder since it
                  just can upload the invoices on the chosen folder
                </Typography>
              </Grid>
            </Grid> */}

            <div className="mt-2">
              <Alert
                variant="danger"
                show={isMsgShow}
                onClose={handleMsgClose}
                // dismissible
              >
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>
                  It is paid by other method (Not PA Links) but you can switch
                  payment with PALinks by regeneration it.
                </p>
              </Alert>
            </div>

            <Grid container alignItems="center" spacing={3} className="mt-2">
              <Grid item xs={12}>
                <div className="form__group">
                  <label className="form__label">Links</label>

                  <input
                    type="text"
                    id="links"
                    className="form__field"
                    placeholder="Links"
                    value={links}
                    onChange={(e) => {
                      setLinks(e.target.value);
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className="form__group">
                  <label className="form__label">Expired Date</label>
                  <input
                    type="text"
                    id="expiredDate"
                    className="form__field"
                    placeholder="Expired Date"
                    value={expiredDate}
                    onChange={(e) => {
                      setExpiredDate(e.target.value);
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className="form__group">
                  <label className="form__label">Code</label>
                  <input
                    type="text"
                    id="code"
                    className="form__field"
                    placeholder="Code"
                    value={code}
                    onChange={(e) => {
                      this.setCode(e.target.value);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ margin: 3, marginTop: 6 }}>
            <Grid className="flex justify-center gap-[50px]">
              <Grid item xs={3}>
                <button
                  className="w-[120px] bg-[var(--color-primary-purple)] text-white rounded-md py-1 text-center"
                  onClick={handleRegenerate}
                >
                  Regenerate
                </button>
              </Grid>
              <Grid item xs={3}>
                <button
                  className="w-[120px] bg-[var(--color-primary-purple)] text-white rounded-md py-1 text-center"
                  onClick={() => cancelForm()}
                >
                  Cancel
                </button>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </div>
  );
}
